import React from "react";
import Button from "../../../../../../components/ui/Button";
import {DrawingType, Status} from "../../../../../../models/enums";
import {useTranslation} from "react-i18next";
import {useParams} from "react-router-dom";
import {useDrawingDetailsDataContext} from "../../../../providers/DrawingDetailsProvider";
import useCreateAssetPlanFromAsBuilt from "../../../../../project-details/hooks/useCreateAssetPlanFromAsBuilt";
import ConfigHelper from "../config/ConfigHelper";
import {INITIAL_VERSION_ID} from "../../constants";
import {useSelector} from "react-redux";
import {selectScaleConfig} from "../scale/scaleSlice";
import {useProjectDetailContext} from "../../../../../project-details/providers/ProjectDetailProvider";
import {ModalWithTitleAndButtons} from "../../../../../../components/modal";
import {selectEditorIsDirty} from "../view/viewSlice";
import Tooltip from "../../../../../../components/tooltip/Tooltip";

const CreateAssetPlan = ({disabled}: { disabled?: boolean }) => {
	const {t} = useTranslation();
	const scaleConfig = useSelector(selectScaleConfig);
	const {isJobProject} = useProjectDetailContext()
    const isDirty = useSelector(selectEditorIsDirty)
    const {
		projectId,
		drawingId,
		versionId,
		costCenterId,
		sectionId
	} = useParams<{
		projectId: string,
		sectionId: string,
		costCenterId: string,
		drawingId: string,
		versionId: string
	}>();
	const {
		drawingData: {loadStatus: drawingDetailsLoadStatus, drawingDetails}
	} = useDrawingDetailsDataContext();
	const drawingType = drawingDetails?.drawingType ?? DrawingType.TAKE_OFF
	const {createAssetPlan, saveStatus, assetPlanWithNoAssetsActive, handlePromptClose} = useCreateAssetPlanFromAsBuilt(
		projectId, sectionId, costCenterId, drawingId, versionId, drawingDetails?.name ?? "Asset Plan"
	);

	const handleClick = () => createAssetPlan()

	const closeModal = () => {
		if (handlePromptClose) {
			handlePromptClose();
		}
	}

	return (isJobProject && drawingType === DrawingType.AS_BUILT) ? (
		<>
			{assetPlanWithNoAssetsActive && (
				<ModalWithTitleAndButtons
					isOpen={true}
					onClose={closeModal}
					title={t("projects.details.createAssetBuilder.createAssetBuilderErrDescNoAssetsTitle")}
					modalButtons={(<>
						<Button label={t("common.buttons.ok")}
								variant={"primary"}
								onClick={closeModal}/>
					</>)}>
					<div className="confirmation-modal_content">{t("projects.details.createAssetBuilder.createAssetBuilderErrDescNoAssets")}</div>
				</ModalWithTitleAndButtons>
			)}
            <Tooltip tooltipText={isDirty ? t("projects.details.createNewDrawingModal.saveToEnable.create_asset_plan") : ""}>
                <Button variant={"optional"} label={t("projects.details.createNewDrawingModal.title.asset_plan")}
                        onClick={handleClick}
                        disabled={!ConfigHelper.isScaleSet(scaleConfig)
                            || saveStatus === Status.LOADING
                            || isDirty
                            || disabled
                            || versionId === INITIAL_VERSION_ID
                            || drawingDetailsLoadStatus !== Status.SUCCESS}
                />
            </Tooltip>
		</>
	) : null;
};

export default CreateAssetPlan;